import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { loadPresClubRevenueAdmin, loadPresClubUtilizationAdmin } from "../../../redux/actions/PresClubActions";
import RevenueLeaders from "../RevenueLeaders";
import UtilizationLeaders from "../UtilizationLeaders";

class AdminDashboardPage extends React.Component {
  render() {
    return (
      <Container fluid>
        <Row className="justify-content-center">
        {!this.state.revLoading ? 
            <Col lg="4">
              <RevenueLeaders data={this.props.localRevDetails} isAdmin={this.props.localProfile.isAdmin} />
            </Col>
          : <div></div>       
        }
        {!this.state.utilLoading ? 
            <Col lg="4">
              <UtilizationLeaders data={this.props.localUtilDetails} isAdmin={this.props.localProfile.isAdmin} />
            </Col>
          : <div></div>       
        }
        </Row>
 
      </Container>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      revLoading: true,
      utilLoading: true,
    };
  }

  componentDidMount() {
    this.props.loadPresClubRevenueAdmin()
    .then(() => {
      this.setState({revLoading: false})
    })
    .catch((error) => {
      alert("Revenue Leaders did not load: " + error);
    });

    this.props.loadPresClubUtilizationAdmin()
    .then(() => {
      this.setState({utilLoading: false})
    })
    .catch((error) => {
      alert("Utilization Leaders did not load: " + error);
    });

  }

  /*componentDidUpdate() {
      this.props.loadPresClubRevenueAdmin()
        .then(() => this.setState({revLoading: false}))
        .catch((error) => {
          alert("Revenue Leaders did not load: " + error);
          this.setState({revLoading: false});
        });

      this.props.loadPresClubUtilizationAdmin()
        .then(() => this.setState({utilLoading: false}))
        .catch((error) => {
          alert("Utilization Leaders did not load: " + error);
          this.setState({utilLoading: false})
        });
  }*/
  
}

function mapStateToProps(state, ownProps) {
  
  return {
    localRevDetails: state.presClubAdminDetails.revAdminDetails,
    localUtilDetails: state.presClubAdminDetails.utilAdminDetails,
    localProfile: state.profile,
  };
}

const mapDispatchToProps = {
  loadPresClubRevenueAdmin,
  loadPresClubUtilizationAdmin
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboardPage);